import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SettingsCard = styled.div`
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ToggleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${(props) => (props.hasBorder ? '16px' : '0')};
  border-bottom: ${(props) => (props.hasBorder ? '1px solid #e2e8f0' : 'none')};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  transition: opacity 0.2s;
`;

export const ToggleText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 85%;
`;

export const LabelTitle = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme?.colors?.title || '#334155'};
  margin: 0;
  cursor: pointer;
`;

export const LabelSubtitle = styled.span`
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  h3 {
    margin: 0;
    font-size: 15px;
    color: ${({ theme }) => theme?.colors?.title || '#334155'};
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;
  padding-bottom: 10px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 10px;
  }
`;

export const FlavorChip = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px 6px 16px;
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;

  &:hover {
    border-color: #94a3b8;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }
`;

export const CardText = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme?.colors?.text || '#475569'};
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fee2e2;
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #fca5a5;
  }
`;

export const EmptyState = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 20px;
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  text-align: center;
  gap: 10px;

  p {
    margin: 0;
    font-size: 14px;
    color: #475569;
    font-weight: 500;
  }

  span {
    font-size: 12px;
    color: #64748b;
  }
`;
